export interface TRLApplicant {
  hitType: string;
  name: string;
  dob: string;
  ssn: string;
}

export interface TRLScore {
  score: number;
  scoreCodes: string[];
  reason: string;
}

export interface TRLCredit {
  suppressed: boolean;
  freeze: boolean;
  minor: boolean;
  promote: boolean;
  dispute: boolean;
  onFileSince: number;
}

type AddressStatus = 'Current' | 'Previous';

type AddressType = 'Personal' | 'Business';

export interface TRLAddress {
  status: AddressStatus;
  type: AddressType;
  streetName: string;
  streetNumber: number;
  streetType: string;
  city: string;
  state: string;
  zip: number;
  onFileSince: string;
}

export const formattedAddress = (address: TRLAddress) => {
  const { streetName, streetType, streetNumber, city, state, zip } = address;
  const street = [streetNumber, streetName, streetType]
    .filter(Boolean)
    .join(' ');
  return [street, city, state, zip].filter(Boolean).join(', ');
};

export interface TRLEmployment {
  effective: string;
  employer: string;
  occupation: string;
  onFileSince: string;
}

export interface TRL {
  applicant: TRLApplicant;
  trlScore: TRLScore;
  credit: TRLCredit;
  addressHistory: TRLAddress[];
  employmentHistory: TRLEmployment[];
  recordExists: boolean;
}
